import { memo } from "react";
import { Icon } from "@iconify/react";
import { Colors } from "../../utils/colors";
import MessageDataRates from "../MessageDataRates";

// Shown within onboarding to disclose receiving the phone number to send weekly updates
export const WeeklyUpdatesDisclosure = memo(
  function WeeklyUpdatesDisclosureFn() {
    return (
      <>
        <div className="AlignedRow" style={{ gap: 14 }}>
          <Icon
            icon="material-symbols:contact-phone-rounded"
            height={25}
            style={{ color: Colors.GRAY1, flexShrink: 0 }}
          />
          <span className="smallBodySubtext">
            By creating an account, you&apos;ll receive our weekly text updates
            with product tips and more (
            <span style={{ fontWeight: 600 }}>
              we ARE a texting platform after all
            </span>
            ). Msg&Data rates may apply. Text STOP to opt out.
          </span>
        </div>
        <MessageDataRates />
      </>
    );
  }
);
